/**
 * Wrap <select>-Elements in divs with overflow to hide IE9-Styles
 */
var Select = module.exports = function(sel) {
  var parent = sel.parentNode;
  var wrapper = document.createElement("div");
  wrapper.className = "select";
  sel.style.width = "130%";
  sel.style.float = "left";
  parent.replaceChild(wrapper, sel);
  wrapper.appendChild(sel);
};
